// Auth0 Configuration
export const auth0Config = {
  domain: process.env.REACT_APP_AUTH0_DOMAIN!,
  clientId: process.env.REACT_APP_AUTH0_CLIENT_ID!,
  redirectUri: process.env.REACT_APP_AUTH0_REDIRECT_URI || window.location.origin + '/auth0-callback',
  audience: process.env.REACT_APP_AUTH0_AUDIENCE,
  scope: 'openid profile email',
  // Social connections only - no email/password
  connection: '', // Will be set dynamically based on social provider
  // Additional Auth0 configuration for social-only login
  allowSignUp: true,
  allowLogin: true,
  // Disable email/password login - only social providers
  defaultDatabaseConnection: null,
};

// Available social providers
export const socialProviders = {
  google: 'google-oauth2',
  facebook: 'facebook',
  instagram: 'instagram',
  twitter: 'twitter',
  linkedin: 'linkedin',
  github: 'github',
} as const;

export type SocialProvider = keyof typeof socialProviders;
